import { AreaChart } from "@msuite/ui/charts";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { moment } from "@msuite/utils/date";
import { client } from "@/hono";
import type { ArticlePanelBaseProps } from "../shared";

const startDate = moment().subtract(0.5, "years").format("YYYY-MM-DD");

export function ArticleStockBalanceHistory({ articleId }: ArticlePanelBaseProps) {
	const { data } = useQuery({
		queryKey: ["article-stock-balance-history", articleId, startDate],
		queryFn: async () => {
			const response = await client.stock.articles[":articleId"].balance.history.$get({
				param: { articleId },
				query: {
					startDate,
					endDate: moment().format("YYYY-MM-DD"),
				},
			});
			const data = await responseHandler(response);
			return data.history;
		},
	});

	/** Render */
	return (
		<ContentCard
			title="Bestand"
			icon={icon("AArrowDown")}
			contentClassName="h-[300px] p-0! pt-4"
		>
			<AreaChart
				curveType="bump"
				data={guardArray(data).map((item) => ({
					name: item.date,
					quantity: item.quantity,
					warning: item.warningStockBalance,
					minimum: item.minimumStockBalance,
				}))}
				dataKeys={["quantity", "warning", "minimum"]}
				displayKeyMap={{
					quantity: "Bestand",
					warning: "Warnung",
					minimum: "Mindestbestand",
				}}
				dataKeyClasses={{
					quantity: "blue",
					warning: "amber",
					minimum: "red",
				}}
			/>
		</ContentCard>
	);
}
